interface Config {
    baseAddress: string;
}

class ConfigurationService {
    private _configuration: Config = {} as Config;

    get configuration(): Config {
        return this._configuration;
    }

    async load(): Promise<Config | null> {
        try {
            const fileName = `${process.env.PUBLIC_URL}/assets/configs/config.${process.env.REACT_APP_ENV}.json`;
            const response = await fetch(fileName);
            
            if (!response.ok) {
                throw new Error('Failed to read config file');
            }

            this._configuration = await response.json();
            
            return this._configuration;
        } catch (error) {
            console.error('Error occurs when loading config:', error);
            return null;
        }
    }
}

export const configurationService = new ConfigurationService();
